import React, {useEffect} from 'react';
import Background from "../../../assets/atlantis_bg.jpg";
import {Container, Paper} from "@mui/material";
import {LoginStyle} from "../../../styles/pages/auth/LoginStyle";
import Grid from "@mui/material/Grid";
import logo from "../../../assets/v2/atlantis_logo.svg";
import Typography from "@mui/material/Typography";
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import clsx from "clsx";

export const SuccessGoogle = () => {
	const classes = LoginStyle();
	const baseClasses = BaseStyle();

	useEffect(() => {
		document.body.style =
			`background-image: url(${Background});
		background-attachment: fixed;
    background-size: cover;`;
	}, []);

	return (
		<React.Fragment>
			<Container maxWidth={"sm"} className={classes.container} component={"main"}>
				<Paper variant={"elevation"}
				       className={clsx(classes.paper, baseClasses.roundBorder)}
				       elevation={18} component={"article"}>
					<Grid container spacing={2}>
						<Grid item xs={12} className={classes.flexGrid}>
							<img className={classes.logo} src={logo} alt={"logo"}/>
						</Grid>
						<Grid item xs={12}>
							<Typography className={classes.title} variant={"h4"}><b>Associazione eseguita!</b></Typography>
							<Typography className={classes.subTitle} variant={"body1"}>
								Puoi chiudere questa pagina
							</Typography>
						</Grid>
					</Grid>
				</Paper>
			</Container>
		</React.Fragment>
	);
};
